export const validMessage = {
  required: 'Este campo es requerido',
};
